import React, { useState } from 'react';
import { LinkProps } from 'react-router-dom';
import { ButtonLink } from './style';
import { Icon } from 'components';
import { IconsTypes } from 'components/Icon/catalogue';

type VariantThemes = | 'Outline' | 'White' | 'DefaultDark' | 'Default' | 'TextLink' | 'TextLinkBrown'| 'TextLinkPinkLight' | 'TextLinkPinkDark';

interface IButtonProps extends LinkProps {
  variant: VariantThemes;
  typeIcon?: IconsTypes;
  reverseIcon?: boolean;
}

const Button: React.FC<IButtonProps> = ({
  children,
  variant = 'Default',
  typeIcon,
  reverseIcon,
  ...rest
}) => {
  const [themeHover, setThemeHover] = useState(false);

  const handleThemeOver = () => {
    setThemeHover(true);
  };
  const handleThemeOut = () => {
    setThemeHover(false);
  };

 const scrollTop = () => {
   window.scrollTo({ top: 0, behavior: 'smooth' });
 };

  const renderIcon = (selectedtypeIcon: IconsTypes | undefined) => {
    if (variant === 'Default' || variant === 'DefaultDark') {
      if (selectedtypeIcon) {
        return (
          <div style={{ marginLeft: '10px', marginRight: '10px' }}>
            <Icon name={selectedtypeIcon} color={'white'} size={30} />
          </div>
        );
      }

      return null;
    }

    if (variant === 'Outline' || variant === 'White') {
      if (selectedtypeIcon) {
        return (
          <div style={{ marginLeft: '10px', marginRight: '10px' }}>
            <Icon
              name={selectedtypeIcon}
              color={themeHover ? 'white' : '#081D3D'}
              size={30}
            />
          </div>
        );
      }

      return null;
    }
  };

  return (
    <ButtonLink
      {...rest}
      variant={variant}
      reverseIcon={reverseIcon}
      type="button"
      onMouseOver={handleThemeOver}
      onMouseLeave={handleThemeOut}
      onClick={scrollTop}
    >
      {children}
      {renderIcon(typeIcon)}
    </ButtonLink>
  );
};

export default Button;
